/**
 * @description Date 객체를 입력받아 YYYY-MM-DD HH:MM:SS 형식으로 변환하는 함수
 * @param {*} timeStamp - Date 객체 또는 타임스탬프
 * @param {*} dateSeparator
 * @param {*} timeSeparator
 *
 * @returns {string} - YYYY-MM-DD HH:MM:SS 형식의 날짜 문자열
 */
export function formatTimeStamp(timeStamp, dateSeparator = "-", timeSeparator = ":") {
    const date = new Date(timeStamp || Date.now());
    const year = date.getFullYear();
    const month = ("0" + (date.getMonth() + 1)).slice(-2);
    const day = ("0" + date.getDate()).slice(-2);
    const hour = ("0" + date.getHours()).slice(-2);
    const minute = ("0" + date.getMinutes()).slice(-2);
    const second = ("0" + date.getSeconds()).slice(-2);
    return `${year}${dateSeparator}${month}${dateSeparator}${day} ${hour}${timeSeparator}${minute}${timeSeparator}${second}`;
}
/**
 * @description Date 객체를 입력받아 YYYY-MM-DD 형식으로 변환하는 함수
 *
 * @param timeStamp - Date 객체 또는 타임스탬프
 * @param dateSeparator - 날짜 구분자 (기본값: "-")
 *
 * @returns string - YYYY-MM-DD 형식의 날짜 문자열
 */
export function formatDate(timeStamp, dateSeparator = "-") {
    const date = new Date(timeStamp || Date.now());
    const year = date.getFullYear();
    const month = ("0" + (date.getMonth() + 1)).slice(-2);
    const day = ("0" + date.getDate()).slice(-2);
    return `${year}${dateSeparator}${month}${dateSeparator}${day}`;
}
/**
 * @description Date 객체를 입력받아 HH:00:00 형식으로 변환하는 함수
 * @param timeStamp - Date 객체 또는 타임스탬프
 * @returns HH:00:00 형식의 시간 문자열
 */
export function formatHour(timeStamp) {
    const date = new Date(timeStamp || Date.now());
    return date.getHours().toString().padStart(2, "0") + ":00:00";
}
export const formatYYMMDD = (timeStamp) => {
    const date = new Date(timeStamp || Date.now());
    const yy = String(date.getFullYear()).slice(2);
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const dd = String(date.getDate()).padStart(2, "0");
    return `${yy}${mm}${dd}`;
};
